<template>
    <ClientSummary
        v-if="!isError.hasError"
        :client="infoClient"
        :ui="ui"
        :balance="infoClient.total"
        :status-class="typeClassConvenio"
        @back="$emit('back')"
    />
    <div class="container_submenu" v-if="!isError.hasError">
        <header>
            <v-card-title>Administración de Teléfonos</v-card-title>
            <v-divider class="mx-3"></v-divider>
        </header>

        <div class="content_accion">
            <div>
                <v-text-field
                    data-cy="telephone-search"
                    v-model="searchTelefonos"
                    label="Búsqueda"
                    prepend-inner-icon="mdi-magnify"
                    single-line
                    variant="outlined"
                    hide-details
                    class="filter"
                    :disabled="isLoading"
                ></v-text-field>
            </div>
            <div>
                <v-btn
                    icon="mdi-reload"
                    size="small"
                    variant="outlined"
                    color="indigo-darken-3"
                    class="mr-2"
                    :disabled="isLoading"
                    data-cy="telephone-refresh"
                    @click="getTelephonesByClient()"
                ></v-btn>
                <v-btn
                    prepend-icon="mdi-plus"
                    color="indigo-darken-3"
                    class="elevation-0 text-none"
                    @click="typeFormListaTelefono.type = 'R'; dialogFormListaTelefono = true;"
                    :disabled="isLoading"
                    text="Registrar"
                ></v-btn>
            </div>
        </div>
        <v-data-table
            data-cy="telephone-table"
            :headers="dataSourceTelefonos.headers"
            :items="dataSourceTelefonos.data"
            :search="searchTelefonos"
            :loading="isLoading"
            no-data-text="Sin datos para mostrar"
            loading-text="Cargando información... Espere un momento"
        >
            <template v-slot:loading>
                <v-skeleton-loader type="table-row@3" aria-label="Cargando teléfonos" />
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <td>
                    <v-tooltip text="Eliminar" location="bottom" v-if="tipoUsuario === 'Administrador'">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                v-bind="props"
                                class="elevation-0"
                                density="comfortable"
                                icon="mdi-delete"
                                color="error"
                                :disabled="isLoading"
                                @click="deleteTelephoneNumber(item)"
                            ></v-btn>
                        </template>
                    </v-tooltip>
                </td>
            </template>
        </v-data-table>
    </div>
    <div v-if="isError.hasError && !isLoading" class="has_error">
        <div>
            <img src="@/assets/images/hasError.svg">
        </div>
        <div>{{ isError.msg }}</div>
    </div>

    <template>
        <v-dialog v-model="dialogFormListaTelefono" width="300px" persistent>
            <v-card>
            <v-card-title class="text-h5">{{ typeFormListaTelefono.type === 'R' ? 'Registro de Teléfono' : 'Modificación de Teléfono' }}</v-card-title>
            <v-card-text>
                <form class="override_content_flex">
                    <div class="col-flex-12">
                        <v-text-field
                            label="Número de Teléfono"
                            type="number"
                            variant="outlined"
                            v-model="inputTelephoneNumber"
                            :rules="ruleTelephoneNumber"
                            maxlength="10"
                            v-on:input="limitarTel"
                            class="w-100"
                            onkeydown="return event.key !== 'e'"
                        ></v-text-field>
                    </div>
                </form>
            </v-card-text>

            <v-card-actions class="actions_buttons">
                <v-btn 
                    variant="flat"
                    class="text-none"
                    color="red"
                    @click="dialogFormListaTelefono = false; inputTelephoneNumber = '';"
                    text="Cerrar"
                ></v-btn>
                <v-btn 
                    variant="flat"
                    class="text-none"
                    color="indigo-darken-3"
                    :loading="isLoadingForm" 
                    @click="dialogSaveListaTelefono = true" 
                    :disabled="inputTelephoneNumber.toString().length < 10"
                    text="Aceptar"
                ></v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
    </template>

    <!-- Confirmación Teléfono -->
    <template>
        <v-dialog v-model="dialogSaveListaTelefono" width="400px" persistent>
            <v-card>
                <v-card-title class="text-h5">Confirmación</v-card-title>
                <v-card-text>
                    <div v-if="!isLoading">
                        <div class="text-center">
                            <img src="@/assets/images/warning.png">
                        </div>
                        <div class="description-text">

                            <p v-if="typeFormListaTelefono.type === 'R'">¿Está seguro de registrar el teléfono?</p>
                            <p v-if="typeFormListaTelefono.type === 'M'">¿Está seguro de modificar el teléfono?</p>
                        </div>
                    </div>
                    <div class="content_load" v-if="isLoading">
                        <v-progress-circular
                            :size="100"
                            :width="7"
                            color="indigo-darken-3"
                            indeterminate
                        ></v-progress-circular>
                        <i>Espere un momento</i>
                        <div>Guardando la información</div>
                    </div>
                </v-card-text>
                <v-card-actions class="actions_buttons" v-if="!isLoading">
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="red"
                        @click="dialogSaveListaTelefono = false"
                        text="Cerrar"
                    ></v-btn>
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="indigo-darken-3"
                        v-if="typeFormListaTelefono.type === 'R'" 
                        @click="createTelephoneByClient()" 
                        :loading="idLoading"
                        text="Guardar"
                    ></v-btn>
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="indigo-darken-3"
                        v-if="typeFormListaTelefono.type === 'M'" 
                        @click="modifyTelephone()" 
                        :loading="idLoading"
                        text="Guardar"
                    ></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </template>

    <template>
        <v-dialog v-model="dialogDeleteListaTelefono" width="400px" persistent>
            <v-card>
                <v-card-title class="text-h5">Confirmación</v-card-title>
                <v-card-text>
                    <div v-if="!isLoading">
                        <div class="text-center">
                            <img src="@/assets/images/warning.png">
                        </div>
                        <div class="description-text">
                            <p>¿Está seguro de eliminar el teléfono?</p>
                        </div>
                    </div>
                    <div class="content_load" v-if="isLoading">
                        <v-progress-circular
                            :size="100"
                            :width="7"
                            color="indigo-darken-3"
                            indeterminate
                        ></v-progress-circular>
                        <i>Espere un momento</i>
                        <div>Guardando la información</div>
                    </div>
                </v-card-text>
                <v-card-actions class="actions_buttons">
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="red"
                        @click="dialogDeleteListaTelefono = false"
                        text="Cerrar"
                    ></v-btn>
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="indigo-darken-3"
                        :disable="isLoading" 
                        @click="deleteTelephone()"
                        text="Aceptar"
                    ></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </template>

    <SnackbarComponent :value="snackbarData"/>
</template>
<script>
import ClientSummary from '@/components/managements/ClientSummary.vue'
import { EncryptService } from '@/services/EncryptService'
import { ManagementsService } from '@/services/ManagementsService'
import SnackbarComponent from '@/components/Snackbar'
import { ResourcesService } from '@/services/ResourcesService'
import { useUiStore } from '@/stores/ui'

export default {
    name: "TelephoneManagement",
    emits: ['back'],
    props: {
        msg: String,
    },
    components: {
        ClientSummary,
        SnackbarComponent,
    },    
    data() {
        return {
            idClient: null,
            searchTelefonos: '',
            isLoading: false,
            dialogFormListaTelefono: false,
            dialogSaveListaTelefono: false,
            dialogDeleteListaTelefono: false,
            isError: {
                hasError: false,
                msg: '',
            },
            snackbarData: {
                openSnackbar: false,
                description: '',
            },
            dataSourceTelefonos: {
                data: [],
                headers: [
                    { align: "start", key: "numero_tel", title: "Número de Teléfono" },
                    { key: "mismo_numero", title: "Clientes con el Mismo Número" },
                    { key: "prioridad", title: "Número de Exitos" },
                    { key: "actions", title: "Acciones" },
                ],
            },
            inputTelephoneNumber: '',
            ruleTelephoneNumber: [
                value => {
                    if (value === null || value === '' || value === undefined) {
                        return `Este campo es obligatorio`
                    }
                    if (value.toString().length < 10) {
                        return `El campo debe incluir 10 digitos`
                    }
                }
            ],
            typeFormListaTelefono: {
                type: '',
                id: ''
            },
            infoClient: {
                id_cliente: "...",
                nombre: "...",
                saldo: "...",
                estado: "...",
            },
            typeClassConvenio: 'gray',
            permissions: true,

        }
    },
    computed:{
        ui() {
            const store = useUiStore()
            return store.ui;
        },
    },
    async mounted() {
        const store = useUiStore()
        if (Object.keys(store.ui).length === 0) {
            await store.cargarVocabulario()
        }
    },
    async created() {
        this.tipoUsuario = await EncryptService.decrypt(localStorage.getItem('TIPO'));

        const DATA_PARAMS = this.$route.params.form
        if (DATA_PARAMS === null || DATA_PARAMS === undefined || DATA_PARAMS === '') {
            this.isError.hasError = true
            this.isError.msg = `No existen datos en la URL para obtener la información del cliente. Favor de volver a ingresar al cliente`
            return;
        }
        const PARAMS = await EncryptService.decrypt(DATA_PARAMS)
        if (PARAMS === null || PARAMS === '') {
            this.isError.hasError = true
            this.isError.msg = `Los datos de la URL no fueron encriptados correctamente. Favor de volver a ingresar al cliente.`
            return;
        }
        const ARR_PARAMS = JSON.parse(PARAMS);
        this.idClient = ARR_PARAMS.id

        const ENC_TYPE = localStorage.getItem('TIPO');
        const TYPE = await EncryptService.decrypt(ENC_TYPE);
        if (TYPE === 'Gestor' || TYPE === 'Colaborador') {
            this.permissions = false;
            this.dataSourceTelefonos.headers.pop();
        }

        this.isLoading = true
        await this.getClientInformation()
        await this.getTelephonesByClient()
        this.isLoading = false
    },
    methods: {
        getClientInformation: async function () {
            const ENC_CLIENT = await EncryptService.encrypt(this.idClient)
            await ManagementsService.getClientInformation(ENC_CLIENT).then(
                (responseData) => {
                    if (!responseData.error) {
                        this.infoClient = responseData.response
                        this.infoClient.total = ResourcesService.moneyFormat(this.infoClient.total)
                        switch (this.infoClient.estado) {
                            case 'Convenio Activo':
                            case 'Convenio Completado':
                            case 'Pago Intención Activo':
                            case 'Pago Intención Completado':
                                this.typeClassConvenio = 'green';
                                break;
                            case 'Sin convenio':
                                this.typeClassConvenio = 'gray';
                                break;
                            case 'Convenio Cancelado':
                            case 'Pago Intención Cancelado':
                                this.typeClassConvenio = 'red';
                                break;
                            default:
                                this.typeClassConvenio = 'gray';
                        }
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
        },
        getTelephonesByClient: async function () {
            this.isLoading = true
            try {
                const encryptedClient = await EncryptService.encrypt(this.idClient)
                const result = await ManagementsService.getTelephonesByClient(encryptedClient)
                if (result.error) {
                    this.snackbarData.description = result.msg
                    this.snackbarData.openSnackbar = true
                } else {
                    this.dataSourceTelefonos.data = result.response.map(phone => ({
                        ...phone,
                        mismo_numero: phone.relacion.length,
                        reaction: -1,
                    }))
                }
            } catch {
                this.snackbarData.description = 'No se pudo cargar la información. Intente de nuevo.'
                this.snackbarData.openSnackbar = true
            } finally {
                this.isLoading = false
            }
        },
        editTelephoneNumber: function (item) {
            this.typeFormListaTelefono.type = 'M'
            this.typeFormListaTelefono.id = item.id_tel
            this.dialogFormListaTelefono = true
            this.inputTelephoneNumber = parseInt(item.numero_tel)
        },
        deleteTelephoneNumber: function (item) {
            this.typeFormListaTelefono.id = item.id_r_c_t
            this.dialogDeleteListaTelefono = true
        },
        limitarTel: function () {
            this.inputTelephoneNumber = this.inputTelephoneNumber.replace(/\D/g, '');
            if (this.inputTelephoneNumber.length > 10) {
                this.inputTelephoneNumber = this.inputTelephoneNumber.slice(0, 10);
            }
        }   ,
        createTelephoneByClient: async function () {
            this.isLoading = true

            const formData = new FormData();
            formData.append("telefono", await EncryptService.encrypt(this.inputTelephoneNumber.toString().trim()));
            formData.append("id_cliente", await EncryptService.encrypt(this.idClient));

            await ManagementsService.createTelephoneByClient(formData).then(
                async (responseData) =>{
                    if (!responseData.error) {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                        this.isLoading = true
                        await this.getTelephonesByClient()
                        this.isLoading = false
                        this.inputTelephoneNumber = ''
                        this.dialogSaveListaTelefono = false
                        this.dialogFormListaTelefono = false
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoading = false
        },
        modifyTelephone: async function () {
            this.isLoading = true
            const ID_TELEFONO = await EncryptService.encrypt(this.typeFormListaTelefono.id.toString())
            const TELEFONO = await EncryptService.encrypt(this.inputTelephoneNumber.toString().trim())

            await ManagementsService.modifyTelephone(ID_TELEFONO, {telefono: TELEFONO}).then(
                async (responseData) =>{
                    if (!responseData.error) {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                        this.isLoading = true
                        await this.getTelephonesByClient()
                        this.isLoading = false
                        this.inputTelephoneNumber = ''
                        this.dialogSaveListaTelefono = false
                        this.dialogFormListaTelefono = false
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoading = false
        },
        deleteTelephone: async function () {
            this.isLoading = true
            const ID_TELEFONO = await EncryptService.encrypt(this.typeFormListaTelefono.id.toString())

            await ManagementsService.deleteTelephone(ID_TELEFONO).then(
                async (responseData) =>{
                if (!responseData.error) {
                    this.snackbarData.description = '¡Eliminación Exitosa!'
                    this.snackbarData.openSnackbar = true
                    this.isLoading = true
                    await this.getTelephonesByClient()
                    this.isLoading = false
                    this.dialogDeleteListaTelefono = false
                } else {
                    this.snackbarData.description = responseData.msg
                    this.snackbarData.openSnackbar = true
                }
                }
            )
            this.isLoading = false
        },
    }
}
</script>
<style scoped>
    .title_container {
        width: 100%;
        display: flex; 
        justify-content: space-between;
        align-items: center;
        min-height: 50px;
        border-bottom: 1px solid #E3E3E3;
    }
    .title_section {
        width: 25%; 
        display: flex;  
        justify-content: center;
        font-size: 10pt;
    }
    .title_item {
        font-weight: 600;
        margin-right: 4px;
    }
    .container_submenu {
        height: calc(100% - 50px);
        overflow: auto;
        margin-bottom: 30px;
    }
</style>